import defaultAxios from "lib/http/http.common"
import {useMutation, useQuery, useQueryClient} from "react-query"
import {NotificationType, showNotification} from "common/Notification"
import {AxiosError} from "axios"
import {ApiResponse} from "api/common/response"
import {Category} from "dto/category/category"

export const useFindAllCategories = () => {
    return useQuery("/category/find", async () => {
        const result = await defaultAxios.get(`/category`)
        return result?.data?.body
    }, {
        refetchOnMount: true,
        cacheTime: 0,
    })
}

export const useRegisterCategoryMutation = () => {
    const client = useQueryClient()
    return useMutation(async (category: Category) => {
        return defaultAxios.post(`/category`, category)
    }, {
        onSuccess: async () => {
            await client.invalidateQueries("/category/find")
            showNotification("카테고리가 추가되었습니다", NotificationType.SUCCESS)
        },
        onError: (error, variables, context) => {
            try {
                const err = error as AxiosError<ApiResponse<null>>
                showNotification(err.response?.data?.message || "카테고리 추가중 오류가 발생하였습니다")
            } catch (err) {
                showNotification("카테고리 추가중 오류가 발생하였습니다")
            }
        }
    })
}

export const useUpdateCategoryMutation = () => {
    const client = useQueryClient()
    return useMutation(async (category: Category) => {
        return defaultAxios.put(`/category/${category.id}`, category)
    }, {
        onSuccess: async () => {
            await client.invalidateQueries("/category/find")
            showNotification("카테고리가 수정되었습니다", NotificationType.SUCCESS)
        },
        onError: (error, variables, context) => {
            try {
                const err = error as AxiosError<ApiResponse<null>>
                showNotification(err.response?.data?.message || "카테고리 수정중 오류가 발생하였습니다")
            } catch (err) {
                showNotification("카테고리 수정중 오류가 발생하였습니다")
            }
        }
    })
}

export const useDeleteCategoryMutation = () => {
    const client = useQueryClient()
    return useMutation(async (id: number) => {
        return defaultAxios.delete(`/category/${id}`)
    }, {
        onSuccess: async () => {
            await client.invalidateQueries("/category/find")
            showNotification("카테고리가 삭제되었습니다", NotificationType.SUCCESS)
        },
        onError: (error, variables, context) => {
            try {
                const err = error as AxiosError<ApiResponse<null>>
                showNotification(err.response?.data?.message || "카테고리 삭제중 오류가 발생하였습니다")
            } catch (err) {
                showNotification("카테고리 삭제중 오류가 발생하였습니다")
            }
        }
    })
}